import { web3 } from "../web3";
import { recordABI, recordsFactoryABI } from "./abi";

const {
  CONTRACT_DEPLOYED_ADDRESS = "0x746112EBeAEB557D06115087a18c851fEd1D33Cc",
} = process.env;

let recordsInstance;
if (web3)
  recordsInstance = new web3.eth.Contract(
    recordsFactoryABI,
    CONTRACT_DEPLOYED_ADDRESS
  );

export default recordsInstance;

const getRecordInstance = async (address) =>
  await new web3.eth.Contract(recordABI, address);

export { getRecordInstance };
